// extracted by mini-css-extract-plugin
export default {"table1":"tablestyle_table1__RFZH+"};